import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Login", "login"),
    ColumnsFactory.TextColumn("Nombre", "nombre"),
    ColumnsFactory.TextColumn("Perfil", "perfil"),
    ColumnsFactory.TextColumn("Email", "email"),
    ColumnsFactory.BooleanColumn("Centros", "tieneCentros")
  ];
};
